import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Card, Spinner, Table, Alert, Form, Button } from "react-bootstrap";
import { ProductContext } from "../context/AppContext";
import Header from "./Header";
import { Link } from "react-router-dom";
import { all_routes } from "./router/all_routes";

const AttendanceDaily = () => {
    const { GetstudentData } = useContext(ProductContext);
    const authtoken = localStorage.getItem("token");
    const studentId = GetstudentData?.id;
    const userId = GetstudentData?.id;

    // const [studentId, setStudentId] = useState(null);
    const [attendanceData, setAttendanceData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [getAttendance, setGetAttendance] = useState(null);

    // useEffect(() => {
    //     const fetchDaily = async () => {
    //       setLoading(true);
    //       try {
    //         const res = await axios.get(
    //           `https://api.mirai.healthcare/api/attendance/StudentAttendance/daily?student_id=${userId}`,
    //           { headers: { "x-auth": authtoken } }
    //         );
    //         setGetAttendance(res.data);
    //       } catch (error) {
    //         console.error("Error fetching daily attendance:", error);
    //       } finally {
    //         setLoading(false);
    //       }
    //     };
    //     fetchDaily();
    //   }, [userId]);


    useEffect(() => {
        if (!studentId) return;

        const fetchAttendanceData = async () => {
            setLoading(true);
            try {
                const response = await fetch(
                    `https://api.mirai.healthcare/api/attendance/StudentAttendance/daily?student_id=${studentId}`,
                    {
                        headers: { "x-auth": `${authtoken}` },
                    }
                );
                const data = await response.json();
                if (data.success) {
                    setAttendanceData(data?.data || []);
                }
            } catch (err) {
                console.error("Error fetching attendance data:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchAttendanceData();
    }, []);

    console.log(attendanceData, "attendanceData 5000")


    return (
        <div className="page-wrapper">
            <Header />
            <Container fluid className="mt-5" style={{ paddingLeft: "25px", paddingRight: "25px" }}>
                <div className="d-flex justify-content-between align-items-center mb-1">
                    <h5>📅 Student Daily Attendance</h5>
                </div>

                {/* {attendanceData?.classAttendence?.length > 0 ? ( */}
                    <Card className="shadow-sm">
                        <Card.Body>
                            <h5 className="mb-3">🗓️ Attendance Records</h5>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Status</th>
                                        <th>Leave Type</th>
                                        <th>Transport Opted</th>
                                        <th>Notes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* {attendanceData?.classAttendence?.map((item) => ( */}
                                        <tr key={attendanceData?.classAttendence?.id}>
                                            <td>{attendanceData?.classAttendence?.date}</td>
                                            <td className={attendanceData?.classAttendence?.status === "present" ? "text-success" : "text-danger"}>
                                                {attendanceData?.classAttendence?.status.toUpperCase()}
                                            </td>
                                            <td>{attendanceData?.classAttendence?.leave_type || "N/A"}</td>
                                            <td>{attendanceData?.classAttendence?.is_transport_opted ? "Yes" : "No"}</td>
                                            <td>{attendanceData?.classAttendence?.notes || "N/A"}</td>
                                        </tr>
                                    {/* ))} */}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                {/* ) : (
                    <Alert variant="info">No attendance records found.</Alert>
                )} */}
            </Container>
        </div>
    );
};

export default AttendanceDaily
